var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/connections/NotForSale/ZestimateOffer/ZestimateOfferTemplate.jsx";

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import marked from 'marked';
import { Heading, Button, Paragraph, token, spaceMixin, TriggerText, Popper, Popover, TextButton, Text, Flex, Trigger, mediaMixin } from '@zillow/constellation';
import ContactAgentForm, { fetchAbadHtml, submitContact } from '@zillow/off-market-contact-agent-form';
import { useYieldCallback } from '@zillow/yield-callback';
import { MarkDownTextWithToolTip } from '../../../../internal/MarkdownTextWithToolTip';
var StyledWrapper = styled.div.withConfig({
  displayName: "ZestimateOfferTemplate__StyledWrapper",
  componentId: "sc-9dsw9o-0"
})(["background-color:", ";text-align:center;", ""], token('colors.white'), function (_ref) {
  var isNarrowContainer = _ref.isNarrowContainer;
  return !isNarrowContainer && css(["margin:0 ", ";"], spaceMixin('sm'));
}); // This goal of this div is to constrain the width of the fluid Button.
// The div will only grow as wide as the longest text content and the Button
// will only fill that size, rather than the full width of the upsell.

var InlineBlock = styled.div.withConfig({
  displayName: "ZestimateOfferTemplate__InlineBlock",
  componentId: "sc-9dsw9o-1"
})(["display:inline-block;width:100%;"]);
var StyledTriggerText = styled(TriggerText).withConfig({
  displayName: "ZestimateOfferTemplate__StyledTriggerText",
  componentId: "sc-9dsw9o-2"
})(["border:none;color:", ";font-size:14px;line-height:24px;"], token('colors.borderBlue'));
var OfferBreakdownWrapper = styled(Flex).withConfig({
  displayName: "ZestimateOfferTemplate__OfferBreakdownWrapper",
  componentId: "sc-9dsw9o-3"
})(["background-color:", ";"], token('colors.white'));
var CashOfferText = styled(Paragraph).withConfig({
  displayName: "ZestimateOfferTemplate__CashOfferText",
  componentId: "sc-9dsw9o-4"
})(["font-family:Open Sans;"]);
var StyledHeader = styled.div.withConfig({
  displayName: "ZestimateOfferTemplate__StyledHeader",
  componentId: "sc-9dsw9o-5"
})(["width:100%;text-align:left;"]);
var StyledPrintBodyText = styled(Text).withConfig({
  displayName: "ZestimateOfferTemplate__StyledPrintBodyText",
  componentId: "sc-9dsw9o-6"
})(["font-size:12px;line-height:16px;"]);
var StyledPopoverPrintTitleText = styled(Text).withConfig({
  displayName: "ZestimateOfferTemplate__StyledPopoverPrintTitleText",
  componentId: "sc-9dsw9o-7"
})(["font-size:12px;line-height:15px;font-weight:bold;text-transform:uppercase;"]);
var StyledButton = styled(Button).withConfig({
  displayName: "ZestimateOfferTemplate__StyledButton",
  componentId: "sc-9dsw9o-8"
})(["width:100%;height:", ";", ""], spaceMixin(5.5), mediaMixin('lg', css(["", " align-self:end;"], function (props) {
  return !props.isNarrowContainer && 'max-width: 188px;';
})));

function formatStandingOfferPrice(standingOfferPrice) {
  if (standingOfferPrice) {
    return parseInt(standingOfferPrice, 10).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  return null;
}

var ZestimateOfferTemplate = function ZestimateOfferTemplate(_ref2) {
  var titleMarkdownText = _ref2.titleMarkdownText,
      subtitleMarkdownText = _ref2.subtitleMarkdownText,
      actionLink = _ref2.actionLink,
      actionText = _ref2.actionText,
      priceTitleText = _ref2.priceTitleText,
      finePrintTitleText = _ref2.finePrintTitleText,
      finePrintBodyText = _ref2.finePrintBodyText,
      bodyTooltipText = _ref2.bodyTooltipText,
      bodyTooltipLinkText = _ref2.bodyTooltipLinkText,
      bodyTooltipLinkUrl = _ref2.bodyTooltipLinkUrl,
      standingOfferPrice = _ref2.standingOfferPrice,
      onClickUpsellButton = _ref2.onClickUpsellButton,
      onHoverCTA = _ref2.onHoverCTA,
      gaSurface = _ref2.gaSurface,
      gaLocation = _ref2.gaLocation,
      gaTreatment = _ref2.gaTreatment,
      additionalProps = _ref2.additionalProps,
      contactFormVersion = _ref2.contactFormVersion,
      questionnaireLink = _ref2.questionnaireLink,
      trackingParameter = _ref2.trackingParameter,
      isNarrowContainer = _ref2.isNarrowContainer;
  var cashOffer = formatStandingOfferPrice(standingOfferPrice);
  var property = additionalProps.property,
      viewer = additionalProps.viewer,
      abadClient = additionalProps.abadClient,
      zatlasEndpoint = additionalProps.zatlasEndpoint,
      shouldShowcheckBox = additionalProps.shouldShowcheckBox;
  /* set width to prevent IE11 word wrap bug for flex children */

  var titleNode = titleMarkdownText ? /*#__PURE__*/React.createElement(Heading, {
    level: 5,
    mediaQuery: {
      md: {
        marginTop: 'sm'
      }
    },
    style: {
      width: '100%',
      margin: '8px 0px'
    },
    dangerouslySetInnerHTML: {
      __html: marked.parseInline(titleMarkdownText)
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 129,
      columnNumber: 9
    }
  }) : null;
  var onClickBodyTooltipLink = useYieldCallback(function () {
    return window.open(bodyTooltipLinkUrl, '_blank');
  });
  var bodyTooltipPopover = /*#__PURE__*/React.createElement(Popover, {
    closeButton: null // Never show full screen popover modal
    ,
    modal: false,
    body: /*#__PURE__*/React.createElement(React.Fragment, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 152,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Paragraph, {
      fontType: "bodySmall",
      dangerouslySetInnerHTML: {
        __html: marked.parseInline(bodyTooltipText)
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 153,
        columnNumber: 21
      }
    }), bodyTooltipLinkText && bodyTooltipLinkUrl && /*#__PURE__*/React.createElement(TextButton, {
      onClick: onClickBodyTooltipLink,
      fontType: "bodySmallHeading",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 160,
        columnNumber: 25
      }
    }, bodyTooltipLinkText)),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 9
    }
  });
  var subtitleNode = /*#__PURE__*/React.createElement(MarkDownTextWithToolTip, {
    markdownTextInput: subtitleMarkdownText,
    bodyTooltipPopover: bodyTooltipPopover,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 170,
      columnNumber: 9
    }
  });
  var whatsTheNumberPopover = /*#__PURE__*/React.createElement(Popover, {
    closeButton: null // Never show full screen popover modal
    ,
    modal: false,
    body: /*#__PURE__*/React.createElement(Paragraph, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 182,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(StyledPopoverPrintTitleText, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 183,
        columnNumber: 21
      }
    }, finePrintTitleText), /*#__PURE__*/React.createElement("br", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 184,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(StyledPrintBodyText, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 185,
        columnNumber: 21
      }
    }, finePrintBodyText)),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 177,
      columnNumber: 9
    }
  });
  var action = /*#__PURE__*/React.createElement(StyledButton, {
    buttonType: "primary",
    onClick: onClickUpsellButton,
    onMouseEnter: onHoverCTA,
    marginY: "sm",
    isNarrowContainer: isNarrowContainer,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 192,
      columnNumber: 9
    }
  }, actionText);

  if (!actionLink || actionLink === '') {
    action = /*#__PURE__*/React.createElement(Trigger, {
      onOpen: function onOpen() {},
      triggered: function triggered(modalProps, close) {
        return /*#__PURE__*/React.createElement(ContactAgentForm, {
          modalDialogProps: Object.assign(Object.assign({}, modalProps), {}, {
            mediaQuery: {
              xs: {
                fullScreen: true
              },
              md: {
                fullScreen: false
              }
            },
            wide: true
          }),
          shouldSuggestCloseOnSuccess: true,
          property: property,
          contactFormVersion: contactFormVersion,
          viewer: viewer,
          zatlasEndpoint: zatlasEndpoint,
          showCheckBox: shouldShowcheckBox,
          centerAlignedNote: true,
          onClose: close,
          page: gaSurface,
          location: gaLocation,
          treatment: gaTreatment,
          abadClient: abadClient,
          onSubmit: function onSubmit(params) {
            return new Promise(function ($return, $error) {
              return $return(submitContact(params));
            });
          },
          onFetchAbadHtml: function onFetchAbadHtml(params) {
            return new Promise(function ($return, $error) {
              return $return(fetchAbadHtml(params));
            });
          },
          trackingParam: trackingParameter,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 207,
            columnNumber: 21
          }
        });
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 204,
        columnNumber: 13
      }
    }, action);
  }

  return /*#__PURE__*/React.createElement(StyledWrapper, {
    isNarrowContainer: isNarrowContainer,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 239,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(InlineBlock, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 240,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    flexWrap: "wrap",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 241,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(StyledHeader, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 247,
      columnNumber: 21
    }
  }, titleNode, subtitleNode), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    flexShrink: 1,
    flexGrow: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 251,
      columnNumber: 21
    }
  }), /*#__PURE__*/React.createElement(OfferBreakdownWrapper, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 252,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "xs",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 253,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(Text, {
    as: "b",
    fontType: "bodySmall",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 260,
      columnNumber: 29
    }
  }, priceTitleText), !isNarrowContainer ? /*#__PURE__*/React.createElement(CashOfferText, {
    fontColor: "green500",
    fontType: "h4",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 264,
      columnNumber: 33
    }
  }, cashOffer) : null), isNarrowContainer && /*#__PURE__*/React.createElement(CashOfferText, {
    fontColor: "green500",
    fontType: "h4",
    marginRight: "auto",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 270,
      columnNumber: 29
    }
  }, cashOffer), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    justifyContent: isNarrowContainer ? 'flex-start' : 'flex-end',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 274,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(Paragraph, {
    fontType: "legal",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 278,
      columnNumber: 29
    }
  }, /*#__PURE__*/React.createElement(Popper, {
    triggered: whatsTheNumberPopover,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 279,
      columnNumber: 33
    }
  }, /*#__PURE__*/React.createElement(StyledTriggerText, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 280,
      columnNumber: 37
    }
  }, finePrintTitleText)))), action))));
};

ZestimateOfferTemplate.propTypes = process.env.NODE_ENV !== "production" ? {
  standingOfferPrice: PropTypes.string.isRequired,
  questionnaireLink: PropTypes.string,
  onClickUpsellButton: PropTypes.func.isRequired,
  onHoverCTA: PropTypes.func.isRequired,
  gaSurface: PropTypes.string.isRequired,
  gaLocation: PropTypes.string.isRequired,
  gaTreatment: PropTypes.string.isRequired,
  titleMarkdownText: PropTypes.string.isRequired,
  subtitleMarkdownText: PropTypes.string.isRequired,
  actionText: PropTypes.string.isRequired,
  priceTitleText: PropTypes.string.isRequired,
  finePrintTitleText: PropTypes.string.isRequired,
  finePrintBodyText: PropTypes.string.isRequired,
  bodyTooltipText: PropTypes.string,
  bodyTooltipLinkText: PropTypes.string,
  bodyTooltipLinkUrl: PropTypes.string,
  actionLink: PropTypes.string,
  additionalProps: PropTypes.shape({
    property: PropTypes.object,
    viewer: PropTypes.object,
    abadClient: PropTypes.func,
    zatlasEndpoint: PropTypes.string,
    shouldShowcheckBox: PropTypes.bool
  }),

  /**
   * contactAgentForm version to be launched for this upsell
   */
  contactFormVersion: PropTypes.string,
  trackingParameter: PropTypes.string,
  isNarrowContainer: PropTypes.bool
} : {};
ZestimateOfferTemplate.defaultProps = {
  actionLink: '',
  questionnaireLink: '',
  additionalProps: {},
  contactFormVersion: 'estimated-sale-price',
  trackingParameter: '',
  bodyTooltipText: '',
  bodyTooltipLinkText: '',
  bodyTooltipLinkUrl: '',
  isNarrowContainer: false
};
export default ZestimateOfferTemplate;